import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { loaderSx } from "./styles";

export const Loader = ({ height = "100%" }) => {
  return (
    <Box
      height={height}
      sx={loaderSx.container}
    >
      <CircularProgress />
    </Box>
  );
};
export const DarkBgLoader = ({ height = "100%" }) => {
  return (
    <Box
      height={height}
      sx={loaderSx.darkBg}
    >
      <CircularProgress />
    </Box>
  );
}